<template>
    <div>
        <div class="content">
            <div class="flex-center-y center">
                <img :src="imageUrl"/>
                <div class="name">
                    <div>{{detail.content}}</div>
                    <div>{{detail.remark}}</div>
                </div>
            </div>
        </div>
        <div style="border-top: 1px solid #aaa;height: 20px"></div>
        <Form @submit="submit" class="no-border">
            <Field
                    v-model="form.handleRemark"
                    label="处理备注"
                    clearable
                    required
                    placeholder="请输入处理备注"
                    :rules="[{required:true,message:'请输入处理备注'}]"
            />
            <Field
                    v-model="form.handleFileIdList"
                    label="处理照片"
                    clearable
                    style="display: block"
                    :rules="[{required:false,message:'处理照片必填'}]"
            >

                <UploadImage slot="input"
                             :imageList="form.handleFileIdList"
                             type="DeviceImage"
                             :count="4"
                             :sourceType="['camera']"
                             style="margin-left: -12px"
                             @imageChange="changeImageList"
                             edit
                />
            </Field>
            <Button type="info" block class="fixed-bottom-button" native-type="submit">确认提交</Button>
        </Form>
    </div>
</template>

<script>
    import {Button, Divider, Field, Form} from "vant"
    import {downloadImg} from "@/config"
    import UploadImage from "@/components/UploadImage"

    export default {
        components: {UploadImage, Divider, Form, Field, Button},
        props: {},
        data() {
            return {
                id: this.$route.params.id,
                detail: {},
                form: {handleFileIdList:[], handleRemark: ''}
            }
        },
        computed: {
            imageUrl() {
                const {fileIdList} = this.detail
                if (fileIdList && fileIdList.length) {
                    return downloadImg + fileIdList[0]
                }
                return require("./components/images/order.png")
            },
        },
        created() {
        },
        mounted() {
            this.getDetail()
        },
        methods: {
            changeImageList(imageList) {
                this.form.handleFileIdList = imageList;
            },
            getDetail() {
                this.$http.tokiot.safety.danger.get({id: this.id})
                    .then(res => {
                        if (res) {
                            this.detail = res
                        }
                    })
            },
            submit() {
                this.$http.tokiot.safety.danger.submit({id: this.id, ...this.form})
                    .then(ret => {
                        if (ret) {

                            this.$toast.success('提交成功')
                            setTimeout(() => this.$router.go(-1), 1000)
                        }
                    })

            }
        },
        watch: {}
    }
</script>

<style lang="less" scoped>
    .fixed-bottom-button {
        position: fixed;
        margin-left: 8px;
        bottom: 8px;
        width: calc(100% - 16px);
    }

    .content {
        width: 100%;
        & > .center {
            padding: 12px 18px;
            display: flex;
            & > img {
                width: 65px;
                height: 65px;
                // border-radius: 8px;
            }
            & > .name {
                padding-left: 20px;
                height: 100%;
                display: flex;
                flex-direction: column;
                & > div {
                    line-height: 1.8;
                }
            }
        }
    }
</style>